import { FC, useContext, useMemo } from "react";
import './index.css';

import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { StepTwoFormContext } from "../../../../contexts";
import { GenericDataFormContext, QuotationInfoContext, QuotationStep } from "../../../../../../../shared";


interface HeaderTabTheftInsuranceProps {
  id: number;
  areTabActionsAllowed: boolean;
}

export const HeaderTabTheftInsurance: FC<HeaderTabTheftInsuranceProps> = ({ id, areTabActionsAllowed }) => {

  const { tabs, setKeyTabToDelete, setShowModal } = useContext(StepTwoFormContext);
  const { currentStep } = useContext(QuotationInfoContext);
  const { userCanDeleteTabs } = useContext(GenericDataFormContext);
    
  const canNotDeleteTab = useMemo(() => tabs.length === 1 || !userCanDeleteTabs, [tabs, userCanDeleteTabs]);
  
  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '2') {
      setKeyTabToDelete(id);
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: canNotDeleteTab,
    }
  ];

  return (
    <>
      Robo {id}
      {currentStep === QuotationStep.TWO && areTabActionsAllowed && (
        <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']} arrow>
          <Button type='text' className="header-tab-theft-insurance-button">
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </>
  )
}